import * as React from "react"
import { cn } from "@/shared/utils/cn"

export interface DropdownTrayProps {
  isOpen: boolean
  children: React.ReactNode
  className?: string
  align?: "left" | "right" | "center"
  maxHeight?: string
}

const DropdownTray = React.forwardRef<HTMLDivElement, DropdownTrayProps>(
  ({ isOpen, children, className, align = "left", maxHeight = "600px" }, ref) => {
    if (!isOpen) return null

    const alignClasses = {
      left: "left-0",
      right: "right-0",
      center: "left-1/2 -translate-x-1/2",
    }

    return (
      <div
        ref={ref}
        className={cn(
          "absolute top-full mt-1 bg-white border border-gray-300 rounded-md shadow-lg z-50 overflow-y-auto",
          alignClasses[align],
          className
        )}
        style={{ maxHeight }}
      >
        {children}
      </div>
    )
  }
)
DropdownTray.displayName = "DropdownTray"

export { DropdownTray }

